module.exports = __webpack_public_path__ + "static/media/panoram_vorota.0e25b29f.jpg";